module.exports = __webpack_public_path__ + "static/media/iphonexr_splash.ddccaeb1.png";